import React from "react";
import { IAccessApprovals } from "Model/ServerResponse/IAccessApprovals";
import { ACCESS_APPROVALS_ITEMS_TAB_ID } from "../AccessApprovalsUtil";
import Utility from "common/utilities";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, TableCell, TableRow } from "@mui/material";
import { KeyValueList } from "Components2/KeyValueList/KeyValueList";
import "./AccessApprovalsItem.scss";
import { IKeyValue } from "Model/UI/IKeyValue";
import { IAccessApprovalsTab } from "Model/ServerResponse/IAccessApprovalsTab";

export interface IAccessApprovalsItemProp {
  accessApprovalsData: IAccessApprovals;
}

export function AccessApprovalsItem(props: IAccessApprovalsItemProp) {
  let accessApprovalsTabData = props.accessApprovalsData.tabs.find(
    (tab: IAccessApprovalsTab) => tab.tabId === ACCESS_APPROVALS_ITEMS_TAB_ID
  );

  return <div className="access-approvals-tab">{tabAccessApprovalsData()}</div>;

  function tabAccessApprovalsData() {
    if (accessApprovalsTabData && !Utility.isArrayEmpty(accessApprovalsTabData.data)) {
      return (
        <div className="access-approvals-item-rows">
          {getDetailSection(accessApprovalsTabData.data)}
        </div>
      );
    } else {
      return (
        <div className="no-access-approvals-items">
          <p>No Items</p>
        </div>
      );
    }
  }

  function getDetailSection(data: any) {
    const detailsData = getDetailsKeyValueList(data);
    return (
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div className="header-content">
            <b>Details</b>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="border-division">
            <KeyValueList data={detailsData} />
          </div>
        </AccordionDetails>
      </Accordion>
    );
  }

  function getDetailsKeyValueList(data: any): IKeyValue[] {
    const dataArray: IKeyValue[] = [];

    if (data.requestorType)
      dataArray.push({
        _key: "Requestor Type",
        value: data.requestorType,
        seperator: ":",
      });

    if (data.requestsAccessLevels && data.requestsAccessLevels.length > 0) {
      dataArray.push({
        _key: "Request Access Levels",
        value: data.requestsAccessLevels.join("<br/>"),
        seperator: ":",
      });
    }

    if (data.requestsCompetencies && data.requestsCompetencies.length > 0) {
      dataArray.push({
        _key: "Request Competencies",
        value: data.requestsCompetencies.join("<br/>"),
        seperator: ":",
      });
    }

    // if (data.id)
    //   dataArray.push({
    //     _key: "ID",
    //     value: data.id,
    //     seperator: ":",
    //   });

    // if (data.title)
    //   dataArray.push({
    //     _key: "Title",
    //     value: data.title,
    //     seperator: ":",
    //   });

    // if (data.description)
    //   dataArray.push({
    //     _key: "Description",
    //     value: data.description,
    //     seperator: ":",
    //   });

    return dataArray;
  }



}